module.exports = __webpack_public_path__ + "static/media/admin-logo.d70164fe.png";